import { UniButton } from '@/design-system/components/buttons';
import { H6, TextBody, TextCaption } from '@/design-system/components/typography';
import { SxProp, View, Image } from 'dripsy';
import _ from 'lodash';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/design-system/components/icons/Icon';
import { LayoutContext } from 'contexts/LayoutContext';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { LockCardStackParamList } from './type';
import { Card } from '../../../../../../packages/utx-access-client/src/react';
import moment from 'moment-timezone';

export interface UnlockCardProps {
  onClose: () => void;
  onLayout: (event: any) => void;
  account: string;
  tab?: number;
  record?: Card;
  data?: any;
  refresh?: () => void;
}

export const UnlockCardWebOneScreen: React.FC<UnlockCardProps> = (props) => {
  const { onClose, onLayout, account, tab, record, data, refresh } = props;
  const { t } = useTranslation('account-management');
  const layout = useContext(LayoutContext);

  const navigation = useNavigation<NativeStackNavigationProp<LockCardStackParamList>>();

  const [instructionTime, setInstructionTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));

  return (
    <View
      sx={{
        height: layout.isMobile ? '100%' : 'auto',
        width: layout.dimensions.width,
        maxWidth: layout.isMobile ? layout.dimensions.width : Math.min(500, layout.dimensions.width),
        backgroundColor: '$backgroundPrimary'
      }}
      onLayout={(event) => {
        onLayout(event);
      }}>
      <View sx={styles.topHeader}>
        <Icon name="checkCircleBlue" height={108} width={108} />
        <H6 bold sx={styles.textHeaderTitle}>
          {t('card-account-management::unlock-card.title--unlock-card-instruction-placed')}
        </H6>
        <TextCaption sx={styles.subTitle}>{t('card-account-management::unlock-card.text--card-is-now-unlocked')}</TextCaption>
      </View>
      <View sx={styles.body}>
        <Image sx={styles.imageSx} source={record?.product?.imageUrl || require('assets/images/worldcard_blank.png')} />
        <View sx={styles.textGroup}>
          <View sx={{ gap: '$1' }}>
            <H6 semiBold sx={{ color: '$white' }}>
              {record?.embossedName}
            </H6>
            <TextCaption sx={{ color: '$white' }}>**** **** **** {record?.last4}</TextCaption>
          </View>
        </View>
        <View sx={{ mb: '$7' }}>
          <View
            sx={{
              ...styles.horizontalWrapper,
              ...styles.timeView
            }}>
            <TextBody sx={styles.textLabel}>{t('card-account-management::lock-card.text--instruction-time')}</TextBody>
            <TextCaption semiBold sx={styles.textDebitAmount}>
              {data?.instructionTime || instructionTime || '-'}
            </TextCaption>
          </View>
          {/* <View
          sx={{
            ...styles.horizontalWrapper,
            ...styles.refView
          }}>
          <TextBody sx={styles.textLabel}>{t('card-account-management::lock-card.text--ref-id')}</TextBody>
          <TextCaption semiBold sx={styles.textDebitAmount}>
            {data?.refId || '-'}
          </TextCaption>
        </View> */}
        </View>
        <UniButton
          sx={styles.btn}
          labelSx={{ color: '$balck' }}
          label={t('card-account-management::general.button--close')}
          onPress={() => {
            refresh();
            navigation.getParent()?.goBack();
          }}
        />
      </View>
    </View>
  );
};

const styles: Record<string, SxProp> = {
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    background: 'primaryDefault',
    mt: '$10'
  },
  body: {
    minHeight: 200,
    minWidth: 500,
    px: 28,
    py: 28
  },
  horizontalWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textLabel: {
    color: '$textSecondary'
  },
  textDebitAmount: {
    mb: '$1',
    color: '$textPrimary'
  },
  textHeaderTitle: {
    mb: '$2'
  },
  imageSx: {
    width: 444,
    height: 284
  },
  timeView: {
    mb: '$3',
    mt: '$5'
  },
  refView: {
    mb: '$10'
  },
  btn: {
    width: '100%',
    height: 44
  },
  textGroup: {
    position: 'absolute',
    top: 0,
    left: '$10',
    height: 242,
    paddingX: '$4',
    paddingTop: '$11',
    paddingBottom: '$5',
    gap: '$3',
    justifyContent: 'flex-end'
  }
};
